module.exports = __webpack_public_path__ + "img/icon_close_red.9f9b722d.svg";